/** CoStar.Api.ConsumerUserData.TFN.TFNType */
export var TFNType;
(function (TFNType) {
    TFNType[TFNType["Undefined"] = 0] = "Undefined";
    TFNType[TFNType["AC"] = 1] = "AC";
    TFNType[TFNType["google"] = 2] = "google";
    TFNType[TFNType["National"] = 3] = "National";
    TFNType[TFNType["AptHL"] = 4] = "AptHL";
    TFNType[TFNType["OrganicMobile"] = 5] = "OrganicMobile";
    TFNType[TFNType["PaidMobile"] = 6] = "PaidMobile";
    TFNType[TFNType["Apps"] = 7] = "Apps";
    TFNType[TFNType["Agent"] = 8] = "Agent";
})(TFNType || (TFNType = {}));
/** CoStar.Api.ConsumerUserData.TFN.TFNDestintionAudioType */
export var TFNDestintionAudioType;
(function (TFNDestintionAudioType) {
    TFNDestintionAudioType[TFNDestintionAudioType["Undefined"] = 0] = "Undefined";
    TFNDestintionAudioType[TFNDestintionAudioType["Apts"] = 1] = "Apts";
    TFNDestintionAudioType[TFNDestintionAudioType["Rhp"] = 2] = "Rhp";
})(TFNDestintionAudioType || (TFNDestintionAudioType = {}));
